import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Test } from '../../dto/test';
import { TestService } from '../../service/test.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dpi-test-list',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, MatTooltipModule, NgIf],
  templateUrl: './test-list.component.html',
  styleUrl: './test-list.component.scss'
})
export class TestListComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['sn', 'name', 'system', 'subsystem', 'test_objective'];
  dataSource: Test[] = [];
  destroyed$ = new Subject<void>(); // notifier of component being destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;

  constructor(private testService: TestService, private notifyService: StateNotifyService, private router: Router) {
    this.isReadonly = true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.trailSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.reloadAllTests(model.id)
      })

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.isReadonly = res;
      });
  }

  reloadAllTests(trailId: number) {
    this.testService.getAllTestsOfTrail(trailId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: res => {
          this.dataSource = res;
          this.notifyService.updateListAllTests(this.dataSource);
          this.listSize.emit(this.dataSource.length);
        },
        error: err => { console.log(err); this.dataSource = []; }
      });
  }

  selectTest(selected: Test) {
    this.notifyService.updateTestSelection(selected);
    //this.notifyService.updateListAllTests(this.dataSource);
    this.router.navigate(['test-hub']);
  }

  createTest() {
    let trailModel = this.notifyService.getSelectedTrail();
    this.testService.createTest(trailModel.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          this.dataSource.push(model);
          this.selectTest(model);
        },
        error: err => { console.log(err); }
      });
  }

}
